import { Box, Button, Dialog, DialogContent, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Modal, Stack, Typography, keyframes } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Images from '../../../utils/Images';
import { CheckBox, CheckBoxOutlineBlank, FiberManualRecord, FiberManualRecordOutlined } from '@mui/icons-material';
import axios from 'axios';
import { API } from '../../../utils/Api';
import toast from 'react-hot-toast';

const SubscriptionPurchase = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { sub } = location.state || {};
    const { purchase } = location.state || {};
    const [accepted, setAccepted] = useState(false);
    const [shakeTrigger, setShakeTrigger] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const token = localStorage.getItem('token');
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('userDataLogin')));
    const [successModal, setSuccessModal] = useState(false);

    console.log('sub', sub);

    const taxPercent = parseFloat(sub?.taxPercent || '0');
    const price = parseFloat(sub?.price || '0');
    const taxAmount = (price * taxPercent) / 100;
    const totalPayable = price + taxAmount;

    const durationDays = parseInt(sub?.duration || "0", 10);

    // Get today's date
    const startDateObj = new Date();
    const endDateObj = new Date();
    endDateObj.setDate(startDateObj.getDate() + durationDays - 1);
    const dateFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
    const startDate = startDateObj.toLocaleDateString('en-GB', dateFormatOptions);
    const endDate = endDateObj.toLocaleDateString('en-GB', dateFormatOptions);

    const shake = keyframes`
        0% { transform: translateX(0); }
        25% { transform: translateX(-5px); }
        50% { transform: translateX(5px); }
        75% { transform: translateX(-5px); }
        100% { transform: translateX(0); }
    `;

    const handleProceedToBuy = async () => {
        if (!sub?._id || !token) {
            toast.error('Invalid subscription or user info');
            return;
        }

        try {
            const response = await axios.post(
                `${API.BASE_URL}subscription-purchase`,
                {
                    subscriptionId: sub._id,
                    userId: userData?._id,
                    subscriptionType: sub.subscriptionType,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const result = response.data;
            localStorage.setItem('subscriptionPurchaseData', JSON.stringify(sub));
            if (
                result?.status &&
                result?.data?.payment_url &&
                result?.data?.access_code &&
                result?.data?.encRequest
            ) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = result.data.payment_url;
                // form.target = '_blank'; // opens in new tab

                const encRequestInput = document.createElement('input');
                encRequestInput.type = 'hidden';
                encRequestInput.name = 'encRequest';
                encRequestInput.value = result.data.encRequest;

                const accessCodeInput = document.createElement('input');
                accessCodeInput.type = 'hidden';
                accessCodeInput.name = 'access_code';
                accessCodeInput.value = result.data.access_code;

                form.appendChild(encRequestInput);
                form.appendChild(accessCodeInput);
                document.body.appendChild(form);
                form.submit();
            } else {
                toast.error('Unable to initiate payment. Please try again later.');
            }
        } catch (error) {
            console.error('Payment initiation error:', error?.response?.data?.error);
            toast.error(error?.response?.data?.error);
        }
    };

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    return (
        <Box className="subscriptionPurchase">
            <Box padding={2} pb={0}>
                <img style={{ width: '100%' }} src={sub.banner_imageUrl} />
            </Box>
            <Box padding={2}>
                <Typography className='title'>{sub?.title}</Typography>
                <Typography className='description' >{sub?.description}</Typography>

                {sub?.subscriptionWorking?.length > 0 && (
                    <>
                        <Typography className='workTitle'>How does it work?</Typography>
                        <Typography className='workPoints'>After you purchase this subscription</Typography>
                    </>
                )}
                <List dense>
                    {sub?.subscriptionWorking?.map((item, index) => (
                        <ListItem key={index} sx={{ alignItems: 'center', py: 0.5 }}>
                            <ListItemIcon
                                sx={{
                                    minWidth: '24px',
                                    display: 'flex',
                                    alignItems: 'center', // vertical center
                                    justifyContent: 'center', // horizontal center if needed
                                    mt: -1, // ensure no vertical offset
                                }}
                            >
                                <FiberManualRecord sx={{ fontSize: 8, color: '#858585' }} />
                            </ListItemIcon>
                            <ListItemText
                                primaryTypographyProps={{ sx: { fontSize: 14 } }}
                                className="workPoints"
                                primary={item}
                            />
                        </ListItem>
                    ))}
                </List>
                {sub?.termsConditions?.length > 0 && (
                    <Typography className='workTitle'>Terms & Conditions</Typography>
                )}
                <List dense>
                    {sub?.termsConditions.map((item, index) => (
                        <ListItem key={index} sx={{ alignItems: 'center', py: 0.5, m: 0 }}>
                            <ListItemIcon
                                sx={{
                                    minWidth: '24px',
                                    display: 'flex',
                                    alignItems: 'center', // vertical center
                                    justifyContent: 'center', // horizontal center if needed
                                    mt: -1, // ensure no vertical offset
                                }}
                            >
                                <FiberManualRecord sx={{ fontSize: 8, color: '#858585' }} />
                            </ListItemIcon>
                            <ListItemText
                                primaryTypographyProps={{ sx: { fontSize: 14, m: 0, p: 0 } }}
                                className="workPoints"
                                primary={item}
                            />
                        </ListItem>
                    ))}
                </List>

                <>
                    <Stack direction={'row'} alignItems={'center'}>
                        {accepted ? (
                            <CheckBox sx={{ paddingRight: '6px' }} onClick={() => setAccepted(false)} />
                        ) : (
                            <CheckBoxOutlineBlank sx={{ paddingRight: '6px' }} onClick={() => setAccepted(true)} />
                        )
                        }

                        <Typography className='workTitle' onClick={() => setAccepted(prev => !prev)} >Agree to terms & conditions</Typography>
                    </Stack>

                    <Typography
                        className="button"
                        onClick={() => {
                            if (!accepted) {
                                setShakeTrigger(true);
                                return;
                            } else {
                                // navigate('/subscriptions')
                                // handleProceedToBuy();
                                setSuccessModal(true);
                            }
                        }}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                            padding: '12px 0 12px 0',
                            width: 'auto',
                            animation: shakeTrigger ? `${shake} 0.4s ease` : 'none',
                            borderRadius: '30px'
                        }}
                        onAnimationEnd={() => setShakeTrigger(false)}
                    >
                        <Typography color="#fff">Proceed to buy</Typography>
                    </Typography>
                </>

            </Box>

            <Modal open={successModal} onClose={() => setSuccessModal(false)}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '95%', bgcolor: '#fff', borderRadius: '21px', boxShadow: 24, outline: 'none' }}>
                    <DialogContent className="subscriptionPurchaseSuccessModal" sx={{ position: 'relative', overflow: 'visible', py: 2 }} >
                        <img style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center', width: '100%', height: '100%' }} alt='banner imageUrl' src={sub?.banner_imageUrl} />
                        <Typography color={'#0E4961'} pt={1} variant='h6'>{sub?.title}</Typography>
                        <Typography color={'#0E4961'} variant='body2'>Plan Start Date: <b>{startDate}</b></Typography>
                        <Typography color={'#0E4961'} variant='body2' sx={{ borderBottom: '1px solid #0E4961', pb: 1 }}>Plan End Date: <b>{endDate}</b></Typography>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                            Order Summary
                        </Typography>
                        <Stack spacing={1}>
                            <Grid container justifyContent="space-between">
                                <Typography>Item</Typography>
                                <Typography>01</Typography>
                            </Grid>
                            <Grid container justifyContent="space-between">
                                <Typography>Order Total</Typography>
                                <Typography>₹{sub.price}</Typography>
                            </Grid>
                            <Grid container justifyContent="space-between">
                                <Typography>Taxes ({taxPercent}%)</Typography>
                                <Typography>₹{taxAmount.toFixed(2)}</Typography>
                            </Grid>
                            <Divider sx={{ my: 1 }} />
                            <Grid container justifyContent="space-between">
                                <Typography fontWeight={600}>Total Payable</Typography>
                                <Typography fontWeight={600}>₹{totalPayable.toFixed(2)}</Typography>
                            </Grid>
                        </Stack>
                    </DialogContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                            border: '2px solid #00AB55',
                            borderTopRightRadius: '15px',
                            borderTopLeftRadius: '15px',
                            mx: 1,
                            px: 2
                        }}
                    >
                        <Box sx={{ px: 2, py: 1 }}>
                            <Typography sx={{ fontSize: 12, color: '#8f8f8f' }}>
                                Total Payable
                            </Typography>
                            <Typography fontWeight={700}>₹{totalPayable.toFixed(2)}</Typography>
                        </Box>

                        <Box
                            onClick={() => handleProceedToBuy()}
                            sx={{
                                borderRadius: 0,
                                bgcolor: '#00AB55',
                                px: 5,
                                py: 1,
                                borderRadius: '40px',
                                textTransform: 'none',
                                color: '#fff'
                            }}
                        >
                            Proceed To Pay
                        </Box>
                    </Box>
                </Box>
            </Modal>

        </Box>
    )
}

export default SubscriptionPurchase;
